import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, MessageCircle } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhatsAppFab from "../components/WhatsAppFab";
import SEO from "../components/SEO";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { mediaUrl } from "../lib/media";

export default function ServiceDetail() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [svc, setSvc] = useState(null);
  const [projects, setProjects] = useState([]);
  const { pick, lang, t } = useLang();

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/services/${slug}`).then((r) => setSvc(r.data)).catch(() => nav("/"));
    api.get(`/projects?category=${slug}`).then((r) => setProjects(r.data));
  }, [slug, nav]);

  if (!svc) return <div className="min-h-screen bg-[#08080D]" />;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": pick(svc, "title"),
    "description": pick(svc, "description"),
    "image": mediaUrl(svc.cover_image),
    "provider": { "@type": "Organization", "name": "İxirli Reklam & Prodüksiyon" },
    "areaServed": "Türkiye",
    "inLanguage": lang,
  };

  return (
    <>
      <SEO
        title={`${pick(svc, "title")} — İxirli Prodüksiyon`}
        description={pick(svc, "description") || (svc.seo_description || "")}
        image={mediaUrl(svc.cover_image)}
        path={`/services/${svc.slug}`}
        lang={lang}
        jsonLd={jsonLd}
        keywords={[svc.slug]}
      />
      <Header />
      <main className="pt-28 pb-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <button
            onClick={() => nav(-1)}
            className="inline-flex items-center gap-2 text-white/60 hover:text-[#A855F7] text-sm mb-10 transition-colors"
          >
            <ArrowLeft size={14} /> {lang === "tr" ? "Geri" : "Back"}
          </button>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              <div className="font-mono-ui text-[10px] tracking-[0.3em] text-[#A855F7] uppercase mb-4">Service</div>
              <h1 className="font-display text-5xl md:text-7xl uppercase tracking-tighter text-white leading-[0.9]">
                {pick(svc, "title")}
              </h1>
              <p className="mt-8 text-white/60 text-lg">{pick(svc, "description")}</p>
              {pick(svc, "details") && (
                <div className="mt-6 text-white/70 whitespace-pre-wrap leading-relaxed">
                  {pick(svc, "details")}
                </div>
              )}
              <div className="mt-10">
                <button
                  onClick={() => nav("/#contact")}
                  className="btn-primary"
                >
                  <MessageCircle size={14} /> {t("cta_quote")}
                </button>
              </div>
            </div>
            <div className="rounded-3xl overflow-hidden border border-white/5 aspect-[4/5]">
              <img src={mediaUrl(svc.cover_image)} alt="" className="w-full h-full object-cover" />
            </div>
          </div>

          {projects.length > 0 && (
            <div className="mt-24">
              <h3 className="font-display text-3xl uppercase tracking-tight text-white mb-8">
                {lang === "tr" ? "Bu Hizmete Ait Projeler" : "Related Projects"}
              </h3>
              <div className="grid md:grid-cols-3 gap-6">
                {projects.map((p) => (
                  <Link
                    key={p.id}
                    to={`/projects/${p.slug}`}
                    className="group block rounded-2xl overflow-hidden border border-white/5 hover:border-[#A855F7]/50 transition-colors"
                  >
                    <div className="aspect-[4/5] overflow-hidden">
                      <img src={mediaUrl(p.cover_image)} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    </div>
                    <div className="p-4 flex items-center justify-between">
                      <span className="text-white">{pick(p, "title")}</span>
                      <ArrowUpRight size={14} className="text-white/50 group-hover:text-[#A855F7] group-hover:rotate-45 transition-all" />
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
      <WhatsAppFab />
    </>
  );
}
